import apiEwallet from '@/api/ecommerce/ewallet';

const defaultState = () => ({
	listEwallet: [],
	paginationEwallet: '',
	listEwalletDetail: [],
	paginationEwalletDetail: '',
});

const state = defaultState();

const getters = {

};

const mutations = {
	setEwallet(state, data) {
		state.listEwallet = data.data
		state.paginationEwallet = data.pagination;
	},
	setEwalletDetail(state, data) {
		state.listEwalletDetail = data.data
		state.paginationEwalletDetail = data.pagination;
	},
	clearDataEwallet(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getEwallet({ commit, dispatch }, params) {
		apiEwallet.getDataEwallet(params).then(({ data: { data } }) => {
			commit('setEwallet', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setEwallet', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportEwallet({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiEwallet.exportEwallet(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Kurir'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	getEwalletLog({ commit, dispatch }, params) {
		apiEwallet.getDataEwalletLog(params).then(({ data: { data } }) => {
			commit('setEwallet', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setEwallet', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportEwalletLog({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiEwallet.exportEwalletLog(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Kurir'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	getEwalletProcess({ commit, dispatch }, params) {
		apiEwallet.getDataEwalletProcess(params).then(({ data: { data } }) => {
			commit('setEwallet', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setEwallet', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportEwalletProcess({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiEwallet.exportEwalletProcess(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Kurir'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async transferEwallet({ dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await apiEwallet.transferEwallet(params).then(res => {
			const data = res.data;
			dispatch('success', data.message, { root: true })
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
		await dispatch('attempted', null, { root: true })
	},
	getEwalletWithdraw({ commit, dispatch }, params) {
		apiEwallet.getDataEwalletWithdraw(params).then(({ data: { data } }) => {
			commit('setEwallet', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setEwallet', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportEwalletWithdraw({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiEwallet.exportEwalletWithdraw(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Kurir'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	getEwalletDetailWithdraw({ commit, dispatch }, params) {
		apiEwallet.getDataEwalletDetailWithdraw(params).then(({ data: { data } }) => {
			commit('setEwalletDetail', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setEwalletDetail', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportEwalletDetailWithdraw({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiEwallet.exportEwalletDetailWithdraw(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Kurir'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};